import { getMaterialsAnalytics } from '../../api/analytics';
import { deletePRS, getExelExport, getPRS, getPRSTotal } from '../../api/prs';
import { downloadFile } from '../../utils';
import { handleActionAbortController } from '../../utils/handleActionAbortController';

export const CHANGE_PRS_VALUE = 'CHANGE_PRS_VALUE';
export const CHANGE_PRS_SEVERAL_VALUES = 'CHANGE_PRS_SEVERAL_VALUES';
export const RESET_PRS_STORE = 'RESET_PRS_STORE';

export const GET_PRS = 'GET_PRS';
export const GET_PRS_SUCCESS = 'GET_PRS_SUCCESS';
export const GET_PRS_ERROR = 'GET_PRS_ERROR';

export const DELETE_PRS = 'DELETE_PRS';
export const DELETE_PRS_SUCCESS = 'DELETE_PRS_SUCCESS';
export const DELETE_PRS_ERROR = 'DELETE_PRS_ERROR';

export const LOAD_PRS_FILE = 'LOAD_PRS_FILE';
export const LOAD_PRS_FILE_SUCCESS = 'LOAD_PRS_FILE_SUCCESS';
export const LOAD_PRS_FILE_ERROR = 'LOAD_PRS_FILE_ERROR';

export const GET_PRS_ANALYTIC = 'GET_PRS_ANALYTIC';
export const GET_PRS_ANALYTIC_SUCCESS = 'GET_PRS_ANALYTIC_SUCCESS';
export const GET_PRS_ANALYTIC_ERROR = 'GET_PRS_ANALYTIC_ERROR';

export const downloadPRSFile = (params, actions) => {
  return async (dispatch) => {
    dispatch({ type: LOAD_PRS_FILE });
    try {
      const response = await getExelExport(params);
      const { success, results } = response;
      if (success) {
        response.code !== 202 && downloadFile(results, 'application/zip');
        dispatch({ type: LOAD_PRS_FILE_SUCCESS });
        if (actions.onSuccess) {
          actions.onSuccess(response);
        }
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: LOAD_PRS_FILE_ERROR });
      if (actions.onError) {
        actions.onError(error.message);
      }
    }
  };
};

export const getPRSAnalyticAction = (function () {
  let prevController;

  return (params) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_PRS_ANALYTIC, payload: params.cursorDirection === 'FIRST' });
      try {
        const totalParams = {
          startTime: params.startEventTime,
          endTime: params.endEventTime,
          restaurantUuid: params.restaurantsUuid,
          cookingMethod: params.cookingMethod,
          materials: params.materials,
        };
        
        if (params.correctnessTypes) {
          totalParams.correctnessTypes = params.correctnessTypes;
        }
        
        const [response, totalResponse] = await Promise.all([
          getMaterialsAnalytics(params, abortController.signal),
          getPRSTotal(totalParams, abortController.signal),
        ]);

        const { success, results } = response;
        const { success: totalSuccess, results: total } = totalResponse;

        if (success && totalSuccess && !abortController.signal.aborted) {
          dispatch({ type: GET_PRS_ANALYTIC_SUCCESS, payload: { results, total }, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error(error);
          dispatch({ type: GET_PRS_ANALYTIC_ERROR });
        }
      }
    };
  };
})();

export const getPRSAction = (function () {
  let prevController;

  return (params, actions = null) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_PRS, payload: params.cursorDirection === 'FIRST' });
      try {
        const response = await getPRS(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          dispatch({ type: GET_PRS_SUCCESS, payload: results, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error(error);
          actions?.onError(error.message);
          dispatch({ type: GET_PRS_ERROR, params });
        }
      }
    };
  };
})();

export const deletePrsAction = (uuid, actions = null) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_PRS });
    try {
      const response = await deletePRS(uuid);
      const { success } = response;
      if (success) {
        actions?.onSuccess();
        dispatch({ type: DELETE_PRS_SUCCESS });
      }
    } catch (error) {
      console.error(error);
      actions?.onError(error.message);
      dispatch({ type: DELETE_PRS_ERROR });
    }
  };
};

export const changeValue = (key, value) => ({
  type: CHANGE_PRS_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_PRS_SEVERAL_VALUES,
  payload: value,
});

export const resetStore = () => ({
  type: RESET_PRS_STORE,
});
